import { atom } from "jotai"
import { atomWithReset } from "jotai/utils"
import { withImmer } from "jotai-immer"

const formAtom = atomWithReset({
    search: "",
    sort: "a-z",
    filters: {
        openEnrollment: false,
        starts: 'any',
        duration: [],
        tags: []
    }
})

const formImmer = withImmer(formAtom)

export default {
    form: formImmer,
}